import { numberInRange } from "TimeHelper";
import { positionNumberToText } from "Utility";

export type PointsPartition = {
  points: number;
  position: number;
  endPosition?: number;
  name?: string;
};

export const pointsPartitionContainsPosition = (
  column: PointsPartition,
  position: number
) => {
  if (column.position === position) {
    return true;
  }

  if (
    column.endPosition !== undefined &&
    numberInRange(position, column.position, column.endPosition)
  ) {
    return true;
  }

  return false;
};

export const getPointsPartitionTotalRangeSize = (
  partitions: PointsPartition[]
) => {
  return partitions.reduce((a, b) => a + getPointsPartitionRangeSize(b), 0);
};

export const getPointsPartitionRangeSize = (partition: PointsPartition) => {
  if (!partition.endPosition) {
    return 1;
  }

  return partition.endPosition - partition.position + 1;
};

export const getPointsPartitionDisplayText = (partition: PointsPartition) => {
  if (partition.name) {
    return partition.name;
  }

  return `${positionNumberToText(partition.position)}${
    partition.endPosition !== undefined
      ? `-${positionNumberToText(partition.endPosition)}`
      : ""
  }`;
};

export const getPointsPartitionsPointsText = (
  partitions: PointsPartition[]
) => {
  return `${[...partitions]
    .sort((a, b) => a.position - b.position)
    .map((col) => `${getPointsPartitionDisplayText(col)}: ${col.points}`)
    .join(", ")}.`;
};
